module.exports = __webpack_public_path__ + "static/img/store_a.abcd6e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store_a.png
// module id = Ypn2
// module chunks = 1